import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Types } from '@blumtechgroup/blum-ui-utils';

const _createOrganisationUserInitQuery = (organisationId: string) => ({
  organisations_by_pk: params(
    { id: rawString(organisationId) },
    {
      name: types.string,
    }
  ),
});

type X = Types.Unpacked<typeof _createOrganisationUserInitQuery>;
export type Organisation = X['organisations_by_pk'];

export const createOrganisationUserInitQuery = (organisationId: string) =>
  gql`
    ${query(_createOrganisationUserInitQuery(organisationId))}
  `;
